import React from 'react';
import { motion } from 'framer-motion';

const Preloader = () => {
    return (
        <motion.div
            initial={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100vh',
                background: '#fff',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999
            }}
        >
            <div style={{ textAlign: 'center' }}>
                {/* Sun Lanka Logo Animation */}
                <motion.img
                    src="./favicon.png"
                    alt="Loading..."
                    animate={{
                        scale: [1, 1.2, 1],
                        opacity: [1, 0.8, 1],
                        rotate: [0, 360]
                    }}
                    transition={{
                        duration: 3,
                        repeat: Infinity,
                        ease: "linear"
                    }}
                    style={{
                        width: '80px',
                        height: '80px',
                        margin: '0 auto 20px',
                        objectFit: 'contain'
                    }}
                />
                <h2 style={{
                    fontFamily: "'Outfit', sans-serif",
                    color: '#333',
                    letterSpacing: '2px',
                    fontSize: '1.2rem'
                }}>
                    SUN LANKA
                </h2>
                <div style={{
                    width: '40px',
                    height: '2px',
                    background: '#bc002d',
                    margin: '10px auto'
                }} />
            </div>
        </motion.div>
    );
};

export default Preloader;
